import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export type UserStatus = 'Active' | 'Pending' | 'Expired' | 'Deactivated'

interface Props {
  status: UserStatus
}

const statusConfig: Record<UserStatus, { bg: string; color: string }> = {
  Active: { bg: '#d1fae5', color: '#065f46' },
  Pending: { bg: '#fef3c7', color: '#92400e' },
  Expired: { bg: '#d6d8db', color: '#383d41' },
  Deactivated: { bg: '#f8d7da', color: '#FF5959' },
}

export function UserStatusBadge({ status }: Readonly<Props>) {
  const { bg, color } = statusConfig[status]
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        bgcolor: bg,
        borderRadius: '999px',
        px: '12px',
        py: '4px',
        height: '22px',
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: '12px',
          lineHeight: '16px',
          color,
          whiteSpace: 'nowrap',
        }}
      >
        {status}
      </Typography>
    </Box>
  )
}
